import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { FaHome, FaUser, FaChartBar, FaChild, FaClock, FaSyncAlt, FaBox, FaMap } from "react-icons/fa";
import {
  SidebarContainer,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuItem,
  ToggleButton,
  SubmenuList,
  SubmenuItem,
} from "./Sidebar.styles";
import { icon } from "leaflet";
import { getUserProfile } from "../../utils/auth";

const Sidebar = ({ isExpanded, toggleSidebar }) => {
  const userProfile = getUserProfile();
  const [reportsOpen, setReportsOpen] = React.useState(false);

  const menuItems = [
    { label: "Home", link: "/dashboard", icon: <FaHome />, allowedProfiles: ["Administrador", "Regional", "Gestor Municipal"] },
    { label: "Usuários", link: "/users", icon: <FaUser />, allowedProfiles: ["Administrador", "Regional"] },
    { label: "Gestantes", link: "/gestante", icon: <FaChild />, allowedProfiles: ["Administrador", "Regional", "Gestor Municipal"] },
    {
      label: "Relatórios",
      icon: <FaChartBar />,
      allowedProfiles: ["Administrador", "Regional", "Gestor Municipal"],
      children: [
        { label: "Kits", link: "/relatorios/kits", icon: <FaBox /> },
        { label: "Mapa de Calor", link: "/relatorios/mapa", icon: <FaMap /> },
      ],
    },
    { label: "Jobs Agendados", link: "/cron", icon: <FaClock />, allowedProfiles: ["Administrador"] },
    { label: "Sincronizações", link: "/extrator/batches", icon: <FaSyncAlt />, allowedProfiles: ["Administrador"] },
  ];

  return (
    <SidebarContainer isExpanded={isExpanded}>
      <SidebarHeader>
        <h1>{isExpanded ? "Menu" : "M"}</h1>
        <ToggleButton onClick={toggleSidebar}>
          {isExpanded ? "←" : "→"}
        </ToggleButton>
      </SidebarHeader>

      <SidebarMenu>
        {menuItems
          .filter(item => item.allowedProfiles.includes(userProfile))
          .map((item, index) => {
            const hasChildren = Array.isArray(item.children);
            if (!hasChildren) {
              return (
                <SidebarMenuItem key={index} isExpanded={isExpanded}>
                  <Link to={item.link}>
                    <span className="icon">{item.icon}</span>
                    {isExpanded && <span className="label">{item.label}</span>}
                  </Link>
                </SidebarMenuItem>
              );
            }

            return (
              <div key={index}>
                <SidebarMenuItem isExpanded={isExpanded}>
                  <button
                    onClick={() => setReportsOpen(prev => !prev)}
                    style={{
                      background: 'none',
                      border: 'none',
                      color: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      gap: isExpanded ? 10 : 0,
                      width: '100%',
                      cursor: 'pointer',
                      padding: 0,
                    }}
                    aria-expanded={reportsOpen}
                    aria-controls="submenu-relatorios"
                  >
                    <span className="icon">{item.icon}</span>
                    {isExpanded && <span className="label">{item.label}</span>}
                  </button>
                </SidebarMenuItem>
                <SubmenuList id="submenu-relatorios" visible={reportsOpen} isExpanded={isExpanded}>
                  {item.children.map((child, cIdx) => (
                    <SubmenuItem key={`${index}-${cIdx}`} isExpanded={isExpanded}>
                      <Link to={child.link} onClick={() => setReportsOpen(false)}>
                        {isExpanded && <span className="icon">{child.icon}</span>}
                        <span className="label">{child.label}</span>
                      </Link>
                    </SubmenuItem>
                  ))}
                </SubmenuList>
              </div>
            );
          })}
      </SidebarMenu>
    </SidebarContainer>
  );
};

Sidebar.propTypes = {
  isExpanded: PropTypes.bool.isRequired, 
  toggleSidebar: PropTypes.func.isRequired, 
};

export default Sidebar;
